
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $e150464fe9c7cb95$exports = {};

$parcel$export($e150464fe9c7cb95$exports, "LocalStorage", () => $e150464fe9c7cb95$export$19fffca37ef3e106);
class $e150464fe9c7cb95$export$19fffca37ef3e106 {
    constructor(name){
        this.get = this.get.bind(this);
        this.set = this.set.bind(this);
        this.name = name;
    }
    get() {
        const str = window.localStorage.getItem(this.name);
        return JSON.parse(str);
    }
    set(obj) {
        const str = JSON.stringify(obj);
        return window.localStorage.setItem(this.name, str);
    }
}


export {$e150464fe9c7cb95$export$19fffca37ef3e106 as LocalStorage};
//# sourceMappingURL=column-components.d8adac4c.js.map
